export const localStorageKeysPrefix = 'bb-rlv';
export const blackBookPropertyFilters = `${localStorageKeysPrefix}-property-filters`;
export const blackBookGeoFilters = `${localStorageKeysPrefix}-geo-filters`;
export const blackBookInitialFilters = `${localStorageKeysPrefix}-initial-filters`;
export const blackBookSegmentsDateRange = `${localStorageKeysPrefix}-segments-date-range`;
